export const MapIcon = {
  DESTINATION_PATTERN: 'DESTINATION_PATTERN',

  TRAFFIC_INFO_SIGN: 'TRAFFIC_INFO_SIGN',

  PARKING: 'PARKING',
};
